import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Divider } from 'antd'
import { greys } from 'assets/themes/theme-default'

const DividerOverride = ({ large, primary, ...props }) => <Divider {...props} />

const AntDividerStyled = styled(DividerOverride)`
  &&& {
    height: ${props => (props.large ? '6px' : '1px')};
    background-color: ${props => (props.primary ? props.theme.colors.color1.bg : greys.dark3)};
  }
`

DividerOverride.propTypes = {
  large: PropTypes.bool,
  primary: PropTypes.bool
}

export default AntDividerStyled
